import { useState } from "react"
import { Button, Col, Container, Form, Row } from "react-bootstrap"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"
import VrboBulkMode from "./VrboBulkMode"
import VrboMapMode from "./VrboMapMode"

type Mode = 'map' | 'bulk'

const MODES: { key: Mode, label: string, description: string }[] = [
    { key: 'map', label: 'Map', description: 'Paste property IDs to create integrations and sync pricing and availability' },
    { key: 'bulk', label: 'Bulk', description: 'Pick existing VRBO integrations and run actions on them' },
]

export default function VrboMapperPage() {
    const dispatch = useAppDispatch()
    const [mode, setMode] = useState<Mode>('map')

    return (
        <Container>
            <Row>
                <Col>
                    <div className="d-flex justify-content-between align-items-center">
                        <h1>VRBO Mapper</h1>
                        <Button variant="outline-secondary" onClick={() => dispatch(navigateTo('/integrations'))}>
                            Back to Integrations
                        </Button>
                    </div>
                    <hr />

                    <div className="mb-3">
                        {MODES.map(({ key, label }) => (
                            <Form.Check
                                inline
                                key={key}
                                id={`vrbo-mapper-mode-${key}`}
                                type="radio"
                                name="vrbo-mapper-mode"
                                label={`${label} mode`}
                                checked={mode === key}
                                onChange={() => setMode(key)}
                            />
                        ))}
                        <div>
                            <small className="text-muted">{MODES.find(({ key }) => key === mode)?.description}</small>
                        </div>
                    </div>

                    {/* both modes stay mounted so switching doesn't discard a run in progress */}
                    <div className={mode === 'map' ? '' : 'd-none'}>
                        <VrboMapMode />
                    </div>
                    <div className={mode === 'bulk' ? '' : 'd-none'}>
                        <VrboBulkMode active={mode === 'bulk'} />
                    </div>
                </Col>
            </Row>
        </Container>
    )
}
